export const getPageEventsReportTableHeaders = (isExtendedView = true) => {
	if (isExtendedView) {
		return Object.freeze(['No', 'Variant', 'UTM Campaign', 'Source Event Count', 'Target Event Count']);
	}
	return Object.freeze(['No', 'Variant', 'Source Event Count', 'Target Event Count']);
};
